import { render, staticRenderFns } from "./FormComunicationModuleStreamax.vue?vue&type=template&id=c1e7daae&scoped=true&"
import script from "./FormComunicationModuleStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormComunicationModuleStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormComunicationModuleStreamax.vue?vue&type=style&index=0&id=c1e7daae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e7daae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c1e7daae', component.options)
    } else {
      api.reload('c1e7daae', component.options)
    }
    module.hot.accept("./FormComunicationModuleStreamax.vue?vue&type=template&id=c1e7daae&scoped=true&", function () {
      api.rerender('c1e7daae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Network/FormComunicationModuleStreamax.vue"
export default component.exports